
export default class MediaDevices {
  constructor(opt) {
    this.needs_refresh = true;
    this.devices = {};
    this.mirrors = {};
  }

  NSV_create() {
    let v = document.getElementById("__nsv");
    if (!v) {
      let body = document.getElementsByTagName("body")[0];
      v = document.createElement("video");
      //v.src = "https://d1xyplvc108m9i.cloudfront.net/avs30m.mp4";
      v.muted = false;
      v.autoPlay = false;
      //v.controls = true;
      v.setAttribute('playsinline', 'playsinline');
      v.id = "__nsv";
      v.style.position = "fixed";
      v.style.top = "10px";
      v.style.width = "4px";
      v.style.height = "4px";
      v.style["z-index"] = 1000;
      body.appendChild(v);
    }
    return v;
  }

  NSV_update(opt={}) {
    try {
      let md = this;
      if (opt.enable === true) { md.nsv_enable = true; }
      if (!md.nsv_enable) { return; }
      let v = md.NSV_create();
      let needed = true;
      if (md.recordVideo && md.recordVideo.video &&
          md.recordVideo.stream) {
        let active = md.recordVideo.stream.active;
        let tracks = md.recordVideo.stream.getVideoTracks();
        if (!tracks || !tracks.length || !tracks[0].enabled) {
          active = false;
        }
        //console.log("LOOP rv",
        //            active, md.recordVideo.stream.active,
        //            md.recordVideo.video.paused,
        //            md.recordVideo.video.ended);
        if (active &&
            !md.recordVideo.video.paused &&
            !md.recordVideo.video.ended) {
          needed = false;
        }
      }
      if (opt.stop || opt.cleanup) {
        needed = false;
      }

      //console.log("LOOP: NSV play",needed);
      if (needed) {
        //v.src = "https://capture.vuemix.com/v2/stls/playme.m3u8?video=&video_profile=106.99&audio=&audio_profile=2&icl=10&mmc=10&anchor_at=now-60&fps=18";
        v.src = "https://d1xyplvc108m9i.cloudfront.net/ns2h.mp4";
        v.currentTime = 0;
        v.play();
        v.muted = false;
        if (v.paused || v.ended) {
          v.style.border = "2px solid red";
        } else {
          v.style.border = "2px solid green";
        }
      } else if (opt.cleanup) {
        /* Normally we'd pause() for !needed.
         * For now, just keep it always playing even for opt.stop.
         * opt.cleanup is called when we leave the room. */
        v.pause();
        v.style.border = "2px solid transparent";
      }
    } catch(e) {
      console.warn("exception",e);
    }
  }

  getGroups(opt,cb) {
    let md = this;
    let v = [];
    let a = [];
    let o = [];
    let ve = [];
    let ae = [];
    let oe = [];
    if (vx && vx.debug) { console.log("Media: get groups"); }
    md.refreshDevices(opt,function() {
      Object.keys(md.devices.audio).forEach(function(g) {
        let group = md.devices.audio[g];
        if (group.srcs.length > 0) {
          a.push(group.name);
        } else if (group.denied) {
          ae.push({n:group.name,denied:true});
        }
      });
      Object.keys(md.devices.video).forEach(function(g) {
        let group = md.devices.video[g];
        if (group.srcs.length > 0) {
          v.push(group.name);
        } else if (group.denied) {
          ve.push({n:group.name,denied:true});
        }
      });
      Object.keys(md.devices.speaker).forEach(function(g) {
        let group = md.devices.speaker[g];
        if (group.srcs.length > 0) {
          o.push(group.name);
        } else if (group.denied) {
          oe.push({n:group.name,denied:true});
        }
      });
      if (vx && vx.debug) { console.log("Media: groups",JSON.stringify(v), JSON.stringify(ve), JSON.stringify(a), JSON.stringify(ae), JSON.stringify(o), JSON.stringify(oe)); }
      cb && cb({video:v, audio:a, output:o, ve:ve, ae:ae, oe:oe});
    });
  }

  getSources(kind,name,cb) {
    let md = this;
    let srcs = [];
    let group;
    if (vx && vx.debug) { console.log("Media: get sources",kind,name); }
    if (kind == "audio") {
      Object.keys(md.devices.audio).forEach(function(g) {
        let group = md.devices.audio[g];
        if (group.name == name) {
          group.srcs.forEach(function(s) {
            srcs.push({i: g+"|"+s.id, n: s.label});
          });
        }
      });
    }
    if (kind == "video") {
      Object.keys(md.devices.video).forEach(function(g) {
        let group = md.devices.video[g];
        if (group.name == name) {
          group.srcs.forEach(function(s) {
            srcs.push({i: g+"|"+s.id, n: s.label});
          });
        }
      });
    }
    if (kind == "speaker") {
      Object.keys(md.devices.speaker).forEach(function(g) {
        let group = md.devices.speaker[g];
        if (group.name == name) {
          group.srcs.forEach(function(s) {
            srcs.push({i: g+"|"+s.id, n: s.label});
          });
        }
      });
    }
    if (vx && vx.debug) { console.log("Media: sources",JSON.stringify(srcs)); }
    cb && cb(srcs);
  }

  enumAudio(opt,cb) {
    let md = this;
    if (md.devices.audio_enumerated && md.unsafeRefresh) {
      /* userMedia refresh isn't safe. It will clobber existing stream(s) */
      if (vx && vx.debug) { console.log("Media: SKIP audio refresh",JSON.stringify(md.devices.audio)); }
      cb && cb();
      return;
    }

    md.devices.audio =
      {mic:{name:"Microphones", srcs:[], denied:false},
       spk:{name:"System", srcs:[], denied:false}};

    md.devices.speaker =
      {out:{name:"Speakers", srcs:[], denied:false}
       };

    if (navigator.mediaDevices.getDisplayMedia &&
        !opt.skipDisplayAudio) {
      let src = {};
      src.kind = "displayaudio";
      src.id = "default";
      src.label = "System Audio";
      md.devices.audio.spk.srcs.push(src);
    }
    if (!opt.enumerate_audio) {
      /* Return fake option to turn signal enable */
      md.devices.audio.mic.srcs.push({
        kind:"audioinput",id:"enumerate-mic",
        label:"-Click to Allow Access-"
      });
      cb && cb();
      return;
    }

    md.devices.audio_enumerated = true;
    navigator.mediaDevices.getUserMedia({
      audio: true,
    }).then(function(stream) {
      console.log("Media: audio enumerate");
      navigator.mediaDevices.enumerateDevices()
        .then(function(devices) {
          md.needs_refresh = false;
          devices.forEach(function(device) {
            if (vx && vx.debug) {
                console.log("Media: DEV:" + device.kind + ": " + device.label +
                            " id = " + device.deviceId);
            }
            let src = {};
            src.kind = device.kind;
            src.id = device.deviceId;
            src.label = device.label;
            if (device.kind == "audioinput") {
              if (src.id != "communications") {
                md.devices.audio.mic.srcs.push(src);
              }
            } else if (device.kind == "audiooutput") {
              if (src.id != "communications") {
                md.devices.speaker.out.srcs.push(src);
              }
            }
          });
          if (vx && vx.debug) { console.log("Media: audio enumerated"); }
          cb && cb();
        })
        .catch(function(error) {
          console.warn("Media: Unable to enumerate audio:"+error);
          cb && cb();
        });
    }).catch(function (error) {
      let x = ""+error;
      if (x.match(/notallowederror/i)) {
        console.warn("User has disallowed use of the microphone");
        md.devices.audio.mic.denied = true;
      } else {
        console.warn("Media: access error audio:"+error);
      }
      cb && cb();
    });
  }

  enumVideo(opt,cb) {
    let md = this;
    if (md.devices.video_enumerated && md.unsafeRefresh) {
      /* userMedia refresh isn't safe. It will clobber existing stream(s) */
      if (vx && vx.debug) { console.log("Media: SKIP video refresh",JSON.stringify(md.devices.video)); }
      cb && cb();
      return;
    }

    md.devices.video =
      {cam:{name:"Cameras", srcs:[], denied:false},
       dis:{name:"Screenshare", srcs:[], denied:false}};

    if (false && navigator.mediaDevices.getDisplayMedia &&
        !opt.skipDisplayVideo) {
      let src = {};
      src.kind = "displayvideo";
      src.id = "default";
      src.label = "System Display";
      md.devices.video.dis.srcs.push(src);
      src = {};
      src.kind = "displayvideo";
      src.id = "otherdis";
      src.label = "App Window";
      md.devices.video.dis.srcs.push(src);
    }
    if (!opt.enumerate_video) {
      /* Return fake option to turn signal enable */
      md.devices.video.cam.srcs.push({
        kind:"videoinput",id:"enumerate-camera",
        label:"-Click to Allow Access-"
      });
      cb && cb();
      return;
    }

    md.devices.video_enumerated = true;
    navigator.mediaDevices.getUserMedia({
      video: true,
    }).then(function(stream) {
      if (vx && vx.debug) { console.log("Media: video enumerate"); }
      navigator.mediaDevices.enumerateDevices()
        .then(function(devices) {
          md.needs_refresh = false;
          devices.forEach(function(device) {
            if (vx && vx.debug) {
              console.log("Media: DEV:" + device.kind + ": " + device.label +
                          " id = " + device.deviceId);
            }
            let src = {};
            src.kind = device.kind;
            src.id = device.deviceId;
            src.label = device.label;
            if (!src.label.match(/back|rear/i)) {
              src.mirror = true;
            }
            if (device.kind == "videoinput") {
              md.devices.video.cam.srcs.push(src);
            }
          });
          if (vx && vx.debug) { console.log("Media: video enumerated"); }
          cb && cb();
        })
        .catch(function(error) {
          console.warn("Media: Unable to enumerate video:"+error);
          cb && cb();
        });
    }).catch(function (error) {
      let x = ""+error;
      if (x.match(/notallowederror/i)) {
        console.warn("User has disallowed use of the camera");
        md.devices.video.cam.denied = true;
      } else {
        console.warn("Media: access error video:"+error);
      }
      cb && cb();
    });
  }

  refreshDevices(opt,cb) {
    let md = this;
    md.devices = md.devices || {};
    if (vx && vx.debug) { console.log("Media: refresh",JSON.stringify(opt)); }
    md.enumAudio(opt,function() {
      md.enumVideo(opt,cb);
    });
  }

  getOrientationCorrection(dev) {
    let md = this;
    delete dev.orien;
    if (vx && vx.debug) { console.log("Media: getOrientationCorrection",md.cur_gid,dev.is_ios_browser); }
    if (!md.cur_gid || !dev.is_ios_browser) {
      return;
    }

    let [grp,id] = md.cur_gid.split("|");
    let group = md.devices.video[grp];
    if (grp != "cam") {
      return;
    }

    for (let s=0; s < group.srcs.length; s++) {
      if (group.srcs[s].id != id) { continue; }
      let txt = group.srcs[s].label;
      txt = txt.toLowerCase();
      if (/front/.test(txt)) {
        /* button-on-right, portrait, button-on-left */
        dev.orien = {"90": "180", "0": "90", "-90": "0"};
      } else {
        /* back camera is reversed */
        dev.orien = {"90": "0", "0": "90", "-90": "180"};
      }
      if (dev.compute_orientation) {
        dev.compute_orientation(dev.vt);
      }
      return;
    }
  }

  streamAudio(opt, cb) {
    if (vx && vx.debug) { console.log("Media: streamAudio",JSON.stringify(opt)); }
    let md = this;
    let [grp,id] = opt.gid.split("|");
    let group = md.devices.audio[grp];
    let constraint;
    if (!group) {
      console.warn("Media: streamAudio: Invalid group",grp);
      return;
    }

    group.srcs.forEach(function(s) {
      if (s.id == id) {
        constraint = {
          //groupId: s.kind,
          deviceId: s.id,
        };
        if (s.kind == "displayaudio") {
          constraint.is_display_audio = true;
        }
      }
    });
    if (!constraint) {
      console.warn("Media: streamAudio: Invalid id",grp,id);
      return;
    }
    if (vx && vx.debug) { console.log("Media: aconstraint",JSON.stringify(constraint)); }

    if (constraint.is_display_audio) {
      if (md.stream_for_audio) {
        /* Combined video/audio display/speaker streaming */
        console.log("Media: streamAudio: using existing display audio");
        md.streamAudioCapture(opt, md.stream_for_audio, cb);
      } else {
        navigator.mediaDevices.getDisplayMedia({
          video: true, audio: true
        }).then(stream => {
          console.log("Media: streamAudio: setting up display audio");
          let rec_stream = new MediaStream;
          let audio_tracks = stream.getAudioTracks();
          // stopping and removing the video track to enhance the performance
          stream.getVideoTracks()[0].stop();
          stream.removeTrack(stream.getVideoTracks()[0]);
          if (!audio_tracks || !audio_tracks[0]) {
            cb && cb(null,{error:"The selected device lacks audio or you did not enable access to audio."});
            return;
          }
          rec_stream.addTrack(audio_tracks[0].clone());
          audio_tracks[0].stop();
          md.streamAudioCapture(opt, rec_stream, cb);
        }).catch(e => {
          console.warn("Media: streamAudio: display audio error:",e);
          cb && cb(null,{error:"The selected device lacks audio or the system denied access."});
        });
      }
    } else {
      navigator.mediaDevices.getUserMedia({
        audio:constraint,
      }).then(function(stream) {
        console.log("Media: streamAudio: have stream");
        /* Double check our constraint was met */
        let found = false;
        stream.getTracks().forEach(function(t) {
          let s = t.getSettings();
          //console.log(JSON.stringify(s),s);
          if (s.deviceId == constraint.deviceId) {
            found = true;
            if (vx && vx.debug) {
              console.log("Media: stream device",
                          s.deviceId);
            }
          } else {
            console.warn("Media: stream unexpected device",
                         s.deviceId);
          }
        });
        if (!found) {
          console.warn("Media: stream device not found",
                       constraint.deviceId);
        }
        md.streamAudioCapture(opt, stream, cb);
      }).catch(function(e) {
        console.warn("Media: media Error:",e,constraint);
        cb && cb();
      });
    }
  }

  selectAudioCaptureClass(audcap_hint) {
    if (false/*Force Follow Hint*/) {
      console.warn("Forcing audcap",audcap_hint);
      if (audcap_hint == "script") {
         return [AudioRecorderSP, 2048];
      }
      if (audcap_hint == "worklet") {
         return [AudioRecorderWL, 1024];
      }
      return [AudioRecorderMR, 1024];
    }

    if (MediaRecorder.isTypeSupported("audio/webm; codecs=pcm;")) {
      /* Preference MediaRecorder */
      return [AudioRecorderMR, 1024];
    } else if (MediaRecorder.isTypeSupported("audio/mp4")) {
      return [AudioRecorderMR4, 1024];
    }
    let ac = window.AudioContext || window.webkitAudioContext;
    if (typeof AudioWorkletNode !== 'function' ||
        !("audioWorklet" in ac.prototype)) {
      /* AudioWorklet not supported on this browser/device */
      return [AudioRecorderSP, 2048];
    }
    /* Follow hint */
    if (audcap_hint == "script") {
      return [AudioRecorderSP, 2048];
    }
    return [AudioRecorderWL, 1024];
  }

  streamAudioCapture(opt, stream, cb) {
    let md = this;
    // ch:1, 2  size:1024, 2048, 4096, 8192
    let _ch=1,_size, audiorecorder;
    
    [audiorecorder, _size] = md.selectAudioCaptureClass(opt.audcap);

    if (!md.recordAudio) {
      if (opt.sel_idx) {
        throw "Initial capture must configure primary audio";
      }
      md.cb_pushrawAudio = opt.cb_pushraw;
      md.recordAudio = new audiorecorder(stream, {
        numberOfAudioChannels: _ch,
        bufferSize: _size, 
        ondataavailable: function(sr, ch, lbuf, rbuf) {
          let fct = _size/1024;// e.g. 2048/1024 = 2 blocks
          md.cb_pushrawAudio(fct, sr, ch, lbuf, rbuf);
          return true;
        }
      });
      md.recordAudio.setup();
    } else {
      let idx = opt.sel_idx ? 1 : 0;
      md.recordAudio.remAudio(idx);
      md.recordAudio.addAudio(idx,stream);
    }
    cb && cb({x:true});
  }

  removeAudio(opt, cb) {
    let md = this;
    let idx = opt.sel_idx ? 1 : 0;
    /* Remove the audio. Should only occur for non-primary. */
    if (!md.recordAudio) {
      console.warn("cannot remove audio if not capturing");
      return;      
    }
    if (!idx) {
      console.warn("cannot remove primary audio");
      return;
    }
    md.recordAudio.remAudio(idx);
    cb && cb({x:true});
  }

  vtick() {
    let md = this;
    if (md.recordVideo) {
      md.recordVideo.tick();
    }
  }

  set_audio_at(at) {
    let md = this;
    let now = Date.now();
    /* Eventually for mirroring. Just for testing */
    if (md.last_audio_at && (now - md.last_audio_at) < 5000) { return; }
    if (!md.prtc) { return; }
    if (md.prtc.connectionState != "connected") {
      return;
    }
    md.prtc._wss.send("config audioat,"+Date.now()+","+Math.trunc(1000*at));
    md.last_audio_at = now;
  }

  rtcState() {
    let md = this;
    if (!md.prtc) {
      return "off";
    }
    if (md.prtc.connectionState == "connected") {
      return "active";
    }
    return "pending";
  }

  mirrorStatus() {
    let md = this;
    let rv = [];
    Object.keys(md.mirrors).forEach(function(p) {
      let m = md.mirrors[p];
      rv.push({provider:p, status:m.status});
    });
    return rv;
  }

  addRTMP(opt, cb) {
    let md = this;
    let provider = opt.provider;
    let url = opt.url;
    if (md.mirrors[provider]) {
      cb && cb ("exists");
      return;
    }
    md.mirrors[provider] = {
      provider: provider,
      url: url,
      status: "waiting",
    };
    if (!md.prtc || md.prtc.connectionState != "connected" ||
        !md.prtc._searchurl_sent) {
      /* Wait until connected */
    } else if (provider == "_arc") {
      md.prtc._wss.send(`config startarc`);
      md.mirrors[provider].status = "sent";      
    } else {
      md.prtc._wss.send(`config rtmp,${provider},${url}`);
      md.mirrors[provider].status = "sent";
    }
    cb && cb();
  }

  stopRTMP(opt, cb) {
    let md = this;
    let m = md.mirrors[opt.provider];
    if (!m) {
      cb && cb ("notfound");
      return;
    }
    if (m.status == "waiting" ||
        !md.prtc || md.prtc.connectionState != "connected") {
      delete md.mirrors[opt.provider];
      cb && cb();
      return;
    }
    if (opt.provider == "_arc") {
      md.prtc._wss.send(`config stoparc`);
    } else {
      md.prtc._wss.send(`config stoprtmp,${opt.provider}`);
    }
    delete md.mirrors[opt.provider];
    cb && cb();
  }

  sendCMD(cmd, arg, cb) {
    let md = this;
    if (md.prtc && md.prtc._wss) {
      md.prtc._wss.send(`config ${cmd},${arg}`);
    }
    cb && cb();
  }

  startMirror(opt, cb) {
    let md = this;
    if (!vx || !vx.room || !vx.room.name) {
      cb && cb();
      return;
    }
    navigator.mediaDevices.getDisplayMedia({
      video: {
        //width: { ideal: 1024 },
        //height: { ideal: 576 },
        frameRate: 18,
      },
      selfBrowserSurface: "include",
    }).then(stream => {
      if (!md.prtc) {
        console.log("New mirror"); 
        md.PRTC_create(
          stream,
          opt.post_url,
          opt.httphdrs,
          function() {
            md.PRTC_set_max_kbps(md.prtc,2000);
            md.prtc._wss.send("config selfuid,"+vx.user.id);
            window.buildSearchURL(window.vx, function(surl) {
              let handle = opt.handle;
              md.prtc._wss.send(`config searchurl,${handle},${surl}`);
              md.prtc._searchurl_sent = true;
              Object.keys(md.mirrors).forEach(function(p) {
                let m = md.mirrors[p];
                if (m.provider == "_arc") {
                  m.status = "sent";
                  md.prtc._wss.send(`config startarc`);
                } else {
                  m.status = "sent";
                  md.prtc._wss.send(`config rtmp,${m.provider},${m.url}`);
                }
              });
            });
          });
        md.PRTC_start(0);
      } else {
        md.PRTC_replace(stream,true);
      }
      md.endCb = function() {
        /* Do nothing if prtc/wss are dead */
        if (!md.prtc || md.prtc.connectionState != "connected") { return; }
        /* This is called when the user tells the browser to
         *  to stop sharing instead of using our buttons. To
         *  avoid silently streaming nothing, ask user to select
         *  a new stream. */
        md.startMirror({}, function(rsp) {
          if (rsp && rsp.msg) { return; }
          /* User subsequently denied/closed prompt to share something new */
          md.stopCapture();
        });
      }
      cb && cb({msg:"ok"});
    }).catch(e => {
      console.warn("Media: getScreenShareStream: error:",e.name,e);
      if (e.name == "InvalidStateError") {
        /* Likely browser does not think this was from a user action.
         *  Retry via a simple button. */
        if (!md.userpop) {
          let pop = document.createElement("button");
          let body = document.getElementsByTagName("body")[0];
          pop.classList.add("btn-mirror-confirm");
          pop.innerHTML = "Click to allow sharing";
          pop.addEventListener("click", function() {
            md.startMirror(opt,cb);
            md.userpop && md.userpop.remove();
            delete md.userpop;
          });
          md.userpop = pop;
          body.appendChild(pop);
          return;
        }
      }
      cb && cb();
    });
  }

  streamEnd(ev) {
    let md = this;
    ev = ev || {type:"unknown"};
    if (vx && vx.debug) { console.log("streamEnd:",ev.type); }
    /* Goal is to decide if error is related to a screenshare or the
     *  primary video stream (if any) */
    if (ev.type == "rtcfailed") {
      /* If the RTC pipeline failed the track might be ok
         but we've lost hi-res. Call share end (to terminate
         screenshare if any) and primary end (to handle
         webrtc loss) */
      //console.log("streamEnd: rtc loss, endShare");
      md.endShareCb && md.endShareCb(ev);
      //console.log("streamEnd: rtc loss, end");
      md.endCb && md.endCb(ev);

      /* Make sure we do not try to restart rtc, e.g. if
       *  user opens panel, changes devices, etc. */
      //console.log("streamEnd: prtc stop");
      md.PRTC_stop(true);
    } else if (!md.shareStream) {
      /* No screenshare active => for primary */
      //console.log("streamEnd: primary");
      md.endCb && md.endCb(ev);
    } else if (md.isOnlyShare) {
      /* Primary is audio-only => for screenshare */
      //console.log("streamEnd: only share");
      md.endShareCb && md.endShareCb(ev);
    } else {
      /* Track End; from? recordVideo.stream vs shareStream */
      //console.log("streamEnd: track");
      let shareMatch, primMatch;
      if (md.recordVideo && md.recordVideo.stream) {
        md.recordVideo.stream.getVideoTracks().forEach(function(t) {
          if (t.id == ev.target.id) {
            primMatch = true;
          }
        });
      }
      md.shareStream.getVideoTracks().forEach(function(t) {
        if (t.id == ev.target.id) {
          shareMatch = true;
        }
      });
      if (primMatch) {
        //console.log("streamEnd: trackend, end");
        md.endCb && md.endCb(ev);
      } else if (shareMatch) {
        //console.log("streamEnd: trackend, endShare");
        md.endShareCb && md.endShareCb(ev);
      }
    }
  }

  streamVideo(opt, cb, onend) {
    if (vx && vx.debug) { console.log("Media: streamVideo",opt.gid,this.cur_gid); }
    let md = this;
    md.endCb = onend || md.endCb;
    if (!opt.gid) {
      /* Starting off audio only */
      md.streamVideoCapture(opt, null, cb);
      return;
    }

    let [grp,id] = opt.gid.split("|");
    let group = md.devices.video[grp];
    let constraint;
    if (!group) {
      console.warn("Media: streamVideo: Invalid group",grp);
      cb && cb("error");
      return;
    }

    if (opt.gid == md.cur_gid) {
      /* No change in media source */
      md.streamVideoCapture(opt, null, cb);
      return;
    }

    opt.mirror = false;
    group.srcs.forEach(function(s) {
      if (s.id == id) {
        constraint = md.baseConstraint || {
          aspectRatio: { ideal: 1.77777777778 },
          frameRate: 18,
        };
        constraint.deviceId = s.id;
        if (s.kind == "displayvideo") {
          constraint.is_display_video = true;
        }
        opt.mirror = s.mirror || false;
      }
    });
    if (!constraint) {
      console.warn("Media: streamVideo: Invalid id",grp,id);
      return;
    }
    if (vx && vx.debug) { console.log("Media: vconstraint",JSON.stringify(constraint)); }

    if (constraint.is_display_video) {
      /* We only stream video with audio. If audio is also for
         the display (aka speaker) then we want them from the
         same screen share. */
      let audio = false;
      if (opt.agid == "spk|default") {
        audio = true;
      }
      navigator.mediaDevices.getDisplayMedia({
        video: {
          width: { ideal: 1024 },
          height: { ideal: 576 },
          frameRate: 18,
        },
        audio: audio
      }).then(stream => {
        console.log("Media: streamVideo: setting up display video");
        if (audio) {
          console.log("Media: streamVideo: sharing audio from display");
          md.stream_for_audio = stream;
        }
        md.cur_gid = opt.gid;
        md.streamVideoCapture(opt, stream, cb);
      }).catch(e => {
        console.warn("Media: streamVideo: display video error:",e);
        cb && cb("error");
      });
    } else {
      /* Some devices, particularly Safari + iOS 15, can crash
         if getUserMedia is called while RTC stream has 
         an active track */
      md.PRTC_stop_track();

      navigator.mediaDevices.getUserMedia({
        video:constraint,
      }).then(function(stream) {
        console.log("Media: streamVideo: have stream");
        /* Double check our constraint was met */
        let found = false;
        stream.getTracks().forEach(function(t) {
          let s = t.getSettings();
          //console.log(JSON.stringify(s),s);
          if (s.deviceId == constraint.deviceId) {
            found = true;
            if (vx && vx.debug) { 
              console.log("Media: stream device",
                          s.deviceId);
            }
          } else {
            console.warn("Media: stream unexpected device",
                         s.deviceId);
          }
        });
        if (!found) {
          console.warn("Media: stream device not found",
                       constraint.deviceId);
        }
        md.cur_gid = opt.gid;
        md.streamVideoCapture(opt, stream, cb);
      }).catch(function(e) {
        console.warn("Media: streamVideo Error:",e,constraint);
        cb && cb("error");
      });
    }
  }

  streamShare(opt={},cb,onend) {
    let md = this;
    md.endShareCb = onend || md.endShareCb;
    navigator.mediaDevices.getDisplayMedia({
      video: {
        width: { ideal: 1280 },
        height: { ideal: 720 },
        //frameRate: 18
      },
      audio: true
    }).then(stream => {
      md.shareStream = stream;
      if (!md.mode.pt) {
        /* Audio-only + Share (no PT camera) */
        md.isOnlyShare = true;
      } else {
        delete md.isOnlyShare;
      }

      /* Did user include audio */
      if (stream.getAudioTracks()[0]) {
        md.shared_audio = true;
        md.streamAudioCapture({
          sel_idx: 1,
        }, stream);
      } else {
        delete md.shared_audio;
      }

      /* Swaps camera for new share stream */
      md.onShare = false;
      md.swapShare(function(err,rv) {
        if (err) {
          cb && cb("failed");
          return;
        }
        rv.shared_audio = md.shared_audio;
        cb && cb(null,rv);
      });

      stream.getVideoTracks().forEach(function(track) {
        track.onended = function(ev) {
          md.streamEnd(ev);
        }
      });
    }).catch(e => {
      console.warn("screenshare selection failed:",e);
      cb && cb("failed");
    });
  }
  
  /*
  updateBandwidthRestriction(sdp, bandwidth) {
    let modifier = 'AS';
    //if (adapter.browserDetails.browser === 'firefox') {
    //  bandwidth = (bandwidth >>> 0) * 1000;
    //  modifier = 'TIAS';
    //}
    if (sdp.indexOf('b=' + modifier + ':') === -1) {
      // insert b= after c= line.
      sdp = sdp.replace(/c=IN (.*)\r\n/, 'c=IN $1\r\nb=' + modifier + ':' + bandwidth + '\r\n');
    } else {
      sdp = sdp.replace(new RegExp('b=' + modifier + ':.*\r\n'), 'b=' + modifier + ':' + bandwidth + '\r\n');
    }
    return sdp;
  }
  */
 
  PRTC_set_max_kbps(rtc,kbps,fps) {
    if (!rtc) {
      console.warn("prtc: dne");
      return;
    } else if (rtc.connectionState != "connected") {
      console.warn("prtc: not yet connected");
      return;
    }
    let sender = rtc.getSenders()[0];
    let param = sender.getParameters();
    let changed = false;
    //console.log("parameters",JSON.stringify(param));
    if (!param.encodings) param.encodings = [{}];
    if (kbps > 0 && (kbps*1000) != param.encodings[0].maxBitrate) {
      param.encodings[0].maxBitrate = kbps * 1000;
      changed = true;
    } else {
      //delete param.encodings[0].maxBitrate;
    }
    if (fps > 0 && fps != param.encodings[0].maxFramerate) {
      param.encodings[0].maxFramerate = fps;
      changed = true;
    } else {
      //delete param.encodings[0].maxFramerate;
    }
    if (!changed) { return; }
    //console.log("newkbps",JSON.stringify(param));
    sender.setParameters(param).then(() => {
      if (vx && vx.debug) {
        console.log("prtc: kbps parameter set to",
                    param.encodings[0].maxBitrate);
      }
    }).catch(e => console.error("prtc: kbps error",e));
  }
  
  PRTC_wss(rtc, start_ep, cb) {
    let uri = new URL(rtc._url);
    let url = "wss://"+uri.hostname+":8083/rtc";
    rtc._wss = new WebSocket(url);
    rtc._wss.onopen = function() {
      if (vx && vx.debug) { console.log("prtc_wss opened",url,start_ep); }
      let cmd = "start\n";
      /* Required AND must be first */
      cmd += "vx-mode="+rtc._hdrs["vx-mode"]+"\n";
      Object.keys(rtc._hdrs).forEach(function(h) {
        if (h == "vx-mode") { return; }
        cmd += ""+h+"="+rtc._hdrs[h]+"\n";
      });
      if (vx && vx.debug) { console.log("prtc cmd",cmd); }
      //console.log("RTC TX",cmd);
      rtc._wss.send(cmd);
      cb && cb();
    };
    rtc._wss.onmessage = async function(msg) {
      try {
        var obj = JSON.parse(msg.data);
        //console.log("RTC RX",msg.data);
        if (vx && vx.debug) { console.log("prtc_wss onmessage:"+obj.type); }
        switch (obj.type) {
        case "ice":
          await rtc.addIceCandidate(obj);
          break;
        case "offer":
          console.warn("unexpected offer");
          break;
        case "answer":
          let nobj = {type: obj.type};
          /* For unknown reasons, h264 generated by Intel MacAir send to
             playback on a MacM1 results in VDA Error 4 decode error. 
             Only allow most contrained h264 option (one with 'e') in
             answer. */
          nobj.sdp = obj.sdp.replace(/42001f/g,"42e01f");
          //nobj.sdp = obj.sdp.replace(/packetization-mode=0/g,"packetization-mode=1");
          //nobj.sdp = obj.sdp.replace(/packetization-mode=1/g,"packetization-mode=0");
          obj = nobj;
          await rtc.setRemoteDescription(obj);
          break;
        default:
          console.warn("unexpected msg",msg);
        }
      } catch (err) {
        console.log("onmessage error:");
        console.log(err);
        console.log(msg);
      }
    }
    rtc._wss.onclose = function() {
      console.log("prtc_wss closed");
    }
    rtc._wss.onerror = function(ev) {
      console.log("prtc_wss: error:"+ev.type);
      rtc._onend && rtc._onend({type:"rtcfailed",src:"onerror"});
    }
  }

  PRTC_create(stream, url, hdrs, connectcb) {
    let md = this;
    if (md.prtc) { throw "PRTC already created"; }
    if (vx && vx.debug) { console.log("prtc create",url,hdrs); }
    md.prtc = new RTCPeerConnection({
      iceServers: [ { urls: "stun:stun.l.google.com:19302" } ]
    });
    md.prtc._url = url;
    md.prtc._hdrs = hdrs;
    md.prtc._onend = function(ev) {
      md.streamEnd(ev);
    }
    md.prtc.onicecandidate = function(ev) {
      if (ev.candidate) {
        if (vx && vx.debug) { console.log("sendICE candidate"); }
        let ice = JSON.parse(JSON.stringify(ev.candidate));
        ice.type = "ice";
        //console.log("RTC TX",JSON.stringify(ice));
        md.prtc._wss.send(JSON.stringify(ice));
      }
    };
    if ('connectionState' in RTCPeerConnection.prototype) {
      md.prtc.onconnectionstatechange = function() {
        if (vx && vx.debug) { console.log("prtc: "+md.prtc.connectionState); }
        if (md.prtc.connectionState == "connected") {
          connectcb && connectcb();
        }
        if (md.prtc.connectionState == "disconnected" ||
            md.prtc.connectionState == "failed") {
          console.warn("webrtc ended",md.prtc.connectionState,md.prtc.iceConnectionState);
          md.streamEnd({type:"rtcfailed"});
        }
      };
    } else {
      /* Firefox shim */
      md.prtc.oniceconnectionstatechange = function() {
        console.log("prtc ice: "+md.prtc.iceConnectionState);
        if (md.prtc.iceConnectionState == "checking") {
          md.prtc.connectionState = "connecting";
        } else if (md.prtc.iceConnectionState == "completed" ||
                   md.prtc.iceConnectionState == "connected") {
          md.prtc.connectionState = "connected";
        }
        if (md.prtc.connectionState == "connected") {
          connectcb && connectcb();
        }
      }
    }

    clearTimeout(md.tid);
    md.hist_kbps = [];
    md.tid = setInterval(function() {
      if (!md || !md.prtc) {
        clearTimeout(md.tid);
        return;
      }
      md.prtc.getStats().then((stats) => {
        let iw,ih,ow,oh;
        stats.forEach((report) => {
          if (report.type == "candidate-pair") {
            if (report.state == "succeeded" && report.availableOutgoingBitrate) {
              let kbps = Math.trunc(report.availableOutgoingBitrate / 1000);
              md.hist_kbps.unshift(kbps);
              md.hist_kbps.splice(10);
            }
          } else if (report.type == "outbound-rtp") {
            if (report.kind == "video") {
              ow = report.frameWidth;
              oh = report.frameHeight;
            }
          } else if (report.type == "media-source") {
            if (report.kind == "video") {
              iw = report.width;
              ih = report.height;
            }
          }
        });

        let min_kbps = Math.min(...md.hist_kbps);
        let fps = "-";
        if (min_kbps && ow && iw && oh && ih) {
          if (ow < iw && ow < 1280 &&
              oh < ih && oh < 720) {
            if (min_kbps < 600) {
              fps = 4;
            } else {
              fps = 8;
            }
          } else {
            if (min_kbps < 600) {
              fps = 8;
            } else {
              fps = md.max_rtc_fps || 18;
            }
          }
          md.PRTC_set_max_kbps(md.prtc,null,fps);
        }
        if (vx && vx.debug) { console.log("rtc-stat ",iw,ih,ow,oh,min_kbps,"==>",fps); }
      });
    },5000);

    stream.getVideoTracks().forEach(function(track) {
      md.prtc.addTrack(track, stream);
      md.prtc._track = track;
      md.prtc._track.onended = function(ev) {
        md.streamEnd(ev);
      }
    });
  }

  PRTC_start(srvr_start_ep) {
    let md = this;
    if (!md.prtc) { return; }
    md.PRTC_wss(md.prtc, srvr_start_ep, async function() {
      let offer = await md.prtc.createOffer({
        /*offerToReceiveAudio: true,*/ offerToReceiveVideo: true });
      // send the offer to the peer
      //console.log("RTC TX",JSON.stringify(offer));
      md.prtc._wss.send(JSON.stringify(offer));
      // commit the offer locally (note: ice resolution starts)
      await md.prtc.setLocalDescription(offer);
    });
  }

  PRTC_replace(stream, stopold) {
    let md = this;
    if (!md.prtc) {
      md.streamEnd({type:"rtcfailed",src:"nortc"});
      return;
    }
    let videoTrack = stream.getVideoTracks()[0];
    if (!videoTrack) {
      console.warn("No video track in stream");
      md.streamEnd({type:"rtcfailed",src:"novideo"});
      return;
    } else {
      let sender = md.prtc.getSenders().find(function(s) {
        return s.track.kind == videoTrack.kind;
      });
      if (!sender) {
        console.warn("No existing video track found to replace");
        md.streamEnd({type:"rtcfailed",src:"noexitingvideo"});
      } else {
        sender.replaceTrack(videoTrack);
        if (stopold && md.prtc._track) {
          md.prtc._track.stop();
        }
        md.prtc._track = videoTrack;
        md.prtc._track.onended = function(ev) {
          md.streamEnd(ev);
        }
      }
    }
  }

  PRTC_stop_track() {
    let md = this;
    if (!md.prtc) { return; }
    if (md.prtc._track) {
      md.prtc._track.stop();
    }
  }

  PRTC_stop(preserve_track) {
    let md = this;
    clearTimeout(md.tid);
    if (!md.prtc) { return; }
    if (md.prtc._wss) {
      md.prtc._wss.close();
      delete md.prtc._wss;
    }
    if (!preserve_track) {
      md.PRTC_stop_track();
    }
    md.prtc.close();
    delete md.prtc;
  }

  streamVideoStartRTC(stream, kbps) {
    let md = this;
    if (md.prtc) {
      console.warn("streamVideo: rtc exists");
      return;
    }
    if (vx && vx.debug) { console.log("streamVideo: start rtc"); }
    let hdrs = {};
    hdrs["vx-assetid"] = md.ucfg.httphdrs["vx-assetid"];
    hdrs["vxmob-info"] = md.ucfg.httphdrs["vxmob-info"];
    hdrs["vx-mode"] = ("seg "+(1000*md.fmts[0].fps)+" "+md.fmts[0].fpg);
    //hdrs["vx-mode"] = "raw";
    hdrs["vxmob-subgop"] = 3;
    hdrs["vx-rqidx"] = 2;
    hdrs["vxmob-hburl"] = md.ucfg.httphdrs["vxmob-hburl"];
    hdrs["vx-s"] = md.ucfg.httphdrs["vx-s"];

    md.PRTC_create(
      stream,
      md.ucfg.post_url,
      hdrs,
      function() {
        md.PRTC_set_max_kbps(md.prtc,kbps || 800);
      }
    );
  }

  streamVideoCapture(opt, stream, cb) {
    let md = this;
    let start_ep, el;

    if (opt.mode) {
      md.mode = md.mode || {};
      md.mode.sm = opt.mode.sm || false;
      md.mode.pt = opt.mode.pt || false;
    }
    md.cb_pushrawVideo = opt.cb_pushraw || md.cb_pushrawVideo;
    md.fmts = opt.fmts || md.fmts;
    md.ucfg = opt.ucfg || md.ucfg;

    if (!md.recordVideo) {
      md.recordVideo = new VideoRecorder;
      md.recordVideo.capture({
        loopback_refresh: md.loopback_refresh,
        special: md.special,
        fct: 2,
      });
    }
    md.recordVideo.setStream(stream, function(ev) {
      md.streamEnd(ev);
    });
    md.recordVideo.capture({
      en_sm: md.mode.sm,
      en_pt: md.mode.pt,
      bg_ef: opt.bg_ef,
      fmts: md.fmts,
      mirror: opt.mirror,
      ondataavailable: md.cb_pushrawVideo,
    });

    if (md.mode.pt && (opt.rtc || md.prtc)) {
      /* Do not update PRTC if share in progress */
      if (!md.shareVideo) {
        //let use_stream = md.recordVideo.stream;
        let use_stream = md.recordVideo.vcanStream;
        if (!md.prtc && use_stream) {
          /* Start needs to occur using stream from the
             recordVideo object (i.e. new or existing) */
          //console.log("CAPTURE: rtc new");
          md.streamVideoStartRTC(use_stream, 800);
          if (md.recordVideo.capture_start_ep) {
            //console.log("CAPTURE: rtc start",start_ep);
            md.PRTC_start(md.recordVideo.capture_start_ep);
          }
        } else if (use_stream) {
          md.PRTC_replace(use_stream,false);
        }
      }
    }
    let vt = {};
    if (md.mode.sm) { vt.sm = true; }
    if (md.mode.pt && md.prtc) { vt.pt = true; }
    cb && cb("ok", vt);
  }

  swapShare(cb) {
    let md = this;
    //console.log("swapShare",md.onShare);
    if (!md.shareStream) { return; }

    if (md.onShare) {
      md.onShare = false;
      let vt = {};
      if (md.mode.sm) { vt.sm = true; }
      if (!md.isOnlyShare) {
        /* swap from share to camera */
        md.PRTC_replace(md.recordVideo.vcanStream, false);
        md.PRTC_set_max_kbps(md.prtc,800);
        vt.pt = true;
        cb(null,{vt:vt,ss:"-"});
      } else {
        /* swap from share to audio-only / small-only */
        md.streamVideoEnable(false);
        cb(null,{vt:vt,ss:"-"});
      }

      if (md.shareVideo) {
        md.shareVideo.remove();
        delete md.shareVideo;
      }
      if (md.sharePNP) {
        md.sharePNP.remove();
        delete md.sharePNP;
      }
      return;
    }

    /* Switch to (possibly start) screen share.
       Don't use isOnlyShare for this test. Just start webrtc if 
       needed. */
    if (!md.prtc && (md.isOnlyShare || !md.recordVideo)) {
      let opt = {mode:{}};
      opt.mode.pt = true;
      opt.mode.sm = md.mode.sm;
      opt.rtc = true;
      opt.mirror = false;
      md.streamVideoCapture(
        opt,
        md.shareStream,
        function(status, vt) {
          if (status == "ok") {
            cb(null,{vt:vt,ss:"s+ao"});
          } else {
            md.endShareCb && md.endShareCb();
          }
        }
      );
    } else {
      let vt = {pt:true};
      if (md.mode.sm) { vt.sm = true; }
      if (!md.isOnlyShare) {
        /* Camera + Share */
        if (!md.prtc) {
          /* Existing camera flow but likely lost RTC 
           *  at some point */
          md.streamVideoStartRTC(md.shareStream,1500,2);
          md.PRTC_start(0);
        } else {
          /* swap back in screen share */
          md.PRTC_replace(md.shareStream, false);
          md.PRTC_set_max_kbps(md.prtc,1500);
        }

        /* PNP to show share + camera */
        let body = document.getElementsByTagName("body")[0];
        md.shareVideo = document.createElement("video");
        md.shareVideo.srcObject = md.shareStream;
        md.shareVideo.muted = true;
        md.shareVideo.autoPlay = true;
        md.shareVideo.id = "__sharevideo";
        md.shareVideo.style.display = "none";
        md.shareVideo.style.width = "100%";
        md.shareVideo.style.height = "100%";
        md.sharePNP = document.createElement("div");
        md.sharePNP.style.position = "absolute";
        md.sharePNP.style.right = 0;
        md.sharePNP.style.bottom = 0;
        md.sharePNP.style.width = "20%";
        md.sharePNP.style.height = "20%";
        md.sharePNP.style["z-index"] = "1000";
        body.appendChild(md.shareVideo);
        md.shareVideo.play();

        cb(null,{vt:vt,ss:"s+c"});
      } else {
        /* Only share, so no PNP needed */
        md.PRTC_set_max_kbps(md.prtc,1500);
        md.streamVideoEnable(true);
        cb(null,{vt:vt,ss:"s+ao"});
      }
    }

    md.onShare = true;
  }

  streamVideoEnable(enable, cb) {
    let md = this;
    if (!md.fmts || !md.recordVideo || !md.recordVideo.stream) {
      console.warn("not streaming / no video");
      return;
    }
    if (enable) {
      let track = md.recordVideo.vcanStream.getVideoTracks()[0];
      track.enabled = true;
      cb && cb();
    } else {
      let track = md.recordVideo.vcanStream.getVideoTracks()[0];
      track.enabled = false;
      cb && cb();
    }
    md.NSV_update();
  }

  showVideo(el,style) {
    let md = this;
    if (md.shareVideo) {
      /* Place screenshare and PNP div inside 
         designated element */
      el.appendChild(md.shareVideo);
      /* Label and adjust brightness of looped back share
         to avoid confusion */
      if (!md.shareLabel) {
        md.shareLabel = document.createElement("div");
        md.shareLabel.classList.add("screenshare-label");
        md.shareLabel.innerHTML = "Active Screenshare";
      }
      el.appendChild(md.shareLabel);
      md.shareVideo.style.filter = "brightness(0.3)";
      /* Now the PNP */
      el.appendChild(md.sharePNP);
      /* Show camera inside PNP div */
      md.recordVideo.showVideo(md.sharePNP);
      md.shareVideo.style.display = "block";
      md.shareVideo.play();
    } else if (md.recordVideo && md.onShare) {
      /* AudioOnly+Share case. Label and adjust brightness of
         looped back share to avoid confusion */
      if (!md.shareLabel) {
        md.shareLabel = document.createElement("div");
        md.shareLabel.classList.add("screenshare-label");
        md.shareLabel.innerHTML = "Active Screenshare";
      }
      el.appendChild(md.shareLabel);
      style["filter"] = "brightness(0.3)";
      /* Show share inside designated element */
      md.recordVideo.showVideo(el,style);
    } else if (md.recordVideo) {
      /* Show camera inside designated element */
      md.recordVideo.showVideo(el,style);
    }
    md.NSV_update();
  }

  hideVideo() {
    let md = this;
    if (md.recordVideo) {
      md.recordVideo.hideVideo();
    }
    if (md.shareVideo) {
      let body = document.getElementsByTagName("body")[0];
      md.shareVideo.style.display = "none";
      body.appendChild(md.shareVideo);
      md.sharePNP.remove();
    }
  }

  enableCaptureOutput(opt) {
    let md = this;
    if (md.recordAudio) {
      md.recordAudio.recordAt(opt.start_ep);
    }
    if (md.recordVideo) {
      md.recordVideo.recordAt(opt.start_ep);
      md.PRTC_start(opt.srvr_start_ep);
    }
    if (md.capScreen) {
      md.capScreen.startUpload(opt.error_cb);
    }
  }

  stopShare(cb) {
    let md = this;
    if (!md.shareStream) { return; }

    if (md.onShare) {
      /* Swaps camera back in */
      md.swapShare(function(err,rv) {
        if (err) {
          return;
        }
        /* update vt / ss */
        cb && cb(null,rv);
      });
      delete md.onShare;
    }

    if (md.isOnlyShare) {
      md.PRTC_stop();
      md.mode.pt = false;
      if (md.recordVideo) { md.recordVideo.en_pt = false; }
      delete md.cur_gid;
      delete md.isOnlyShare;
    }

    if (md.shareStream) {
      let tracks = md.shareStream.getTracks();
      tracks && tracks.forEach(function(t) {
        t.stop();
      });
      delete md.shareStream;
    }

    if (md.shared_audio) {
      md.removeAudio({
        sel_idx: 1,
      });
      delete md.shared_audio;
    }
  }

  stopCapture(cb) {
    let md = this;
    if (md.recordAudio) {
      md.recordAudio.stop();
      delete md.recordAudio;
      delete md.cb_pushrawAudio;
    }
    if (md.recordVideo) {
      md.recordVideo.stop();
      delete md.recordVideo;
      delete md.cb_pushrawVideo;
    }
    delete md.stream_for_audio;
    if (md.capScreen) {
      md.capScreen.stop();
      delete md.capScreen;
    }
    md.PRTC_stop();
    md.mirrors = {};
    md.mode = {};
    delete md.ucfg;
    delete md.fmts;
    delete md.cur_gid;
    delete md.streaming_video;
    //delete md.rtc_enable;
    delete md.endCb;
    delete md.endShareCb;
    cb && cb();
  }
};

class VideoStreamToImage {
  constructor(mediaStream, config) {
    let rec = this;
    if (!mediaStream || !mediaStream.getVideoTracks().length) {
      throw "videoImage: no video tracks";
    }
    mediaStream.getVideoTracks().forEach(function(t) {
      console.log(t.getSettings());
    });
    rec.posturl = config.posturl;
    rec.stream = mediaStream;
    rec.can = document.createElement("canvas");
    rec.can.id = "__capturecanvas";
    //rec.can.width = 1280;
    //rec.can.height = 720;
    rec.can.style.display = "none";
    let body = document.getElementsByTagName("body")[0];
    body.appendChild(rec.can);
    rec.ctx = rec.can.getContext('2d');
    rec.video = document.createElement("video");
    rec.video.srcObject = rec.stream;
    rec.video.muted = true;
    rec.video.autoPlay = true;
    rec.video.id = "__capvideo";
    rec.video.style.display = "none";
    body.appendChild(rec.video);
  }

  isStreamActive() {
    let rec = this;
    if ('active' in rec.stream) {
      if (!rec.stream.active) {
        return false;
      }
    } else if ('ended' in rec.stream) {
      if (rec.stream.ended) {
        return false;
      }
    }
    return true;
  }

  startUpload(error_cb) {
    let rec = this;
    console.log("videoImage: startUpload");
    rec.video.play();
    rec.tid = setInterval(function() {
      console.log("videoImage: cap/upload interval");
      if (!rec.isStreamActive()) {
        error_cb && error_cb();
        return;
      }
      if (rec.video.videoWidth < 1280 &&
          rec.video.videoHeight < 720) {
        rec.can.width = rec.video.videoWidth;
        rec.can.height = rec.video.videoHeight;
      } else {
        let rw = rec.video.videoWidth / 1280;
        let rh = rec.video.videoHeight / 720;
        if (rw > rh) {
          rec.can.width = rec.video.videoWidth / rw;
          rec.can.height = rec.video.videoHeight / rw;
        } else {
          rec.can.width = rec.video.videoWidth / rh;
          rec.can.height = rec.video.videoHeight / rh;
        }
      }
      rec.ctx.drawImage(rec.video, 0,0,
                        rec.can.width,
                        rec.can.height);

      let dataURL = rec.can.toDataURL("image/jpeg",0.75);
      let base64 = dataURL.substring(23);
      let raw = window.atob(base64);
      let rawLength = raw.length;
      let binobj = new Uint8Array(new ArrayBuffer(rawLength));
      for (i = 0; i < rawLength; i++) {
        binobj[i] = raw.charCodeAt(i);
      }
      console.log("bin:"+rawLength);
      issue_http({
        url: rec.posturl,
        type: "PUT",
        headers:[["x-amz-acl","public-read"],
                 ["cache-control","no-cache"]],
        nocred:true,
        data: binobj,
        done: function(status, data) {
          console.log("status:",status);
        }
      });
    }, 1500);
  }

  stop() {
    let rec = this;
    console.log("videoImage: stop");
    if (rec.tid) {
      clearInterval(rec.tid);
      delete rec.tid;
    }
    if (rec.video) {
      rec.video.remove();
      delete rec.video;
    }
    if (rec.tmp) {
      rec.tmp.remove();
      delete rec.tmp;
    }
    if (rec.can) {
      rec.can.remove();
      delete rec.can;
    }
    if (rec.stream) {
      rec.stream.getVideoTracks().forEach(function(t) {
        t.stop();
      });
      delete rec.stream;
    }
  }
}

class AudioRecorder {
  constructor(config) {
    let rec = this;

    config = config || {};
    this.numberOfAudioChannels = config.numberOfAudioChannels || 1;
    this.ondataavailable = config.ondataavailable;
    if (typeof config.checkForInactiveTracks === 'undefined') {
      this.checkForInactiveTracks = true;
    } else {
      this.checkForInactiveTracks = false;
    }
    this.recording = false;
    this.isPaused = false;

    rec.streams = [];
    rec.audioInputs = [];
  }

  setup() {
  }

  addAudio(idx,stream) {
    let rec = this;
    let atrack = stream.getAudioTracks()[0];
    if (!atrack) { return; }
    rec.streams[idx] = stream;
    rec.audioInputs[idx] = rec.context.createMediaStreamSource(stream);
    rec.audioInputs[idx].connect(rec.gainNode);
    let s = atrack.getSettings();
    return s.sampleRate;
  }
  
  remAudio(idx) {
    let rec = this;
    if (rec.audioInputs[idx]) {
      rec.audioInputs[idx].disconnect();
      rec.audioInputs[idx] = null;
    }
    if (rec.streams[idx]) {
      rec.getTracks(rec.streams[idx], 'audio').forEach(function(t) {
        //console.log("Stop track");
        t.stop();
      });
      rec.streams[idx] = null;
    }
  }
  
  getTracks(stream, kind) {
    if (!stream || !stream.getTracks) {
      return [];
    }
    return stream.getTracks().filter(function(t) {
      return t.kind === (kind || 'audio');
    });
  }

  isMediaStreamActive() {
    let rec = this;
    if (!rec.checkForInactiveTracks) {
      return true;
    }
    if (!rec.streams[0]) {
      return false;
    }
    if ('active' in rec.streams[0]) {
      if (!rec.streams[0].active) {
        return false;
      }
    } else if ('ended' in rec.streams[0]) {
      if (rec.streams[0].ended) {
        return false;
      }
    }
    return true;
  }

  recordAt(start_ep) {
    let rec = this;
    if (!rec.isMediaStreamActive()) {
      throw 'audioRec: Please make sure MediaStream is active.';
    }
    if (vx && vx.debug) { console.log("audioRec: will release input frames @"+start_ep); }
    rec.isPaused = false;
    if (rec.recording) {
      return;
    }
    rec.capture_start_ep = start_ep;
  }

  record() {
    let rec = this;
    if (!rec.isMediaStreamActive()) {
      throw 'audioRec: Please make sure MediaStream is active.';
    }
    console.log("audioRec: releasing input frames");
    rec.isPaused = false;
    rec.recording = true;
  }

  stop() {
    let rec = this;
    console.log("audioRec: stopping");
    rec.recording = false;
    rec.audioInputs.forEach(function(a,idx) {
      rec.remAudio(idx);
    });
    rec.audioInputs = [];
    rec.streams = [];
  }

  pause() {
    let rec = this;
    rec.isPaused = true;
  }

  resume() {
    let rec = this;
    if (!rec.isMediaStreamActive()) {
      throw 'audioRec: Please make sure MediaStream is active.';
    }
    if (!rec.recording) {
      console.log('audioRec: recording resumed.');
      rec.record();
      return;
    }
    rec.isPaused = false;
  }
}

class AudioRecorderMR extends AudioRecorder {
  constructor(mediaStream, config) {
    super(config);
    let rec = this;
    rec.AudioContext = window.AudioContext || window.webkitAudioContext;
    rec.context = new rec.AudioContext();
    rec.bufferSize =
      (typeof config.bufferSize === 'undefined') ? 4096 : config.bufferSize;

    rec.outputNode = rec.context.createMediaStreamDestination();
    /* gainNode will be common sink for all input streams.
       Must occur before first addAudio(). */
    rec.gainNode = rec.context.createGain();
    rec.gainNode.connect(rec.outputNode);
    
    rec.mr = new MediaRecorder(rec.outputNode.stream,
                               {mimeType: "audio/webm; codecs=pcm;"
                               });
    rec.first_time = true;
    rec.mr.ondataavailable = function(e) {
      if (!rec.mr) { return; }
      rec.onAudioDataAvailable(e);
    };
    rec.mr.onstop = function() {
      console.log("mr stop signaled");
      rec.stop();
    };
    /* Milliseconds per output slice */
    rec.mr.start(65);

    rec.addAudio(0,mediaStream);
    /* The output sampleRate of mediaRecorder appears to follow the
       audio context's sampleRate. It might be different than the
       stream's sampleRate. For example, Mac's streams are often 48K
       but their context (thus recorded PCM) are usually 44.1K */
    rec.sampleRate = rec.context.sampleRate;

    console.log(`audioRecMR: Audio ch ${rec.numberOfAudioChannels} sr ${rec.sampleRate} sr ${rec.sampleRate} buf ${rec.bufferSize}`);
  }

  async onAudioDataAvailable(e) {
    let rec = this;
    let at = 0;
    /* Convert input blob to arrayBuffer once and avoid
       blobs. Using a blob costs 2x cpu. */
    let abuf = await e.data.arrayBuffer();

    if (!rec.initBlob) {
      rec.initattempts = 1;
    } else {
      /* Concat */
      let tmp = new Uint8Array(rec.initBlob.length + abuf.byteLength);
      tmp.set(rec.initBlob, 0);
      tmp.set(new Uint8Array(abuf), rec.initBlob.byteLength);
      abuf = tmp.buffer;
    }
    if (rec.first_time) {
      /* decodeAudioData appears to consume/detach abuf 
         so make a copy */
      rec.initBlob = new Uint8Array(abuf.byteLength);
      rec.initBlob.set(new Uint8Array(abuf), 0);
      //console.log("blobsize",rec.initBlob.length);
    } else {
      at = rec.skip_samples;
    }

    let audioBuffer;
    try {
      audioBuffer = await rec.context.decodeAudioData(abuf);
    } catch (e) {
      /* Very small timeslices sometimes cause first blob 
         to contain incomplete webm boxes and thus cannot
         be decoded. Aggregate. */
      if (rec.initattempts++ > 2) {
        console.error("aggregated decode failed",rec.initattempts);
        rec.stop();
      }
      return;
    }

    let remaining = audioBuffer.length - at;
    if (rec.first_time) {
      rec.skip_samples = remaining;
      //console.log("EMN: initial skip "+remaining+" blob "+rec.initBlob.length+" att "+rec.initattempts);
    }
    rec.first_time = false;

    //console.log("audio skip "+at+" len "+audioBuffer.length+" net "+remaining);
    let now = Date.now();
    if (rec.capture_start_ep &&
        now >= rec.capture_start_ep) {
      if (vx && vx.debug) { console.log('audioRec: reached capture start_ep'); }
      rec.recording = true;
      rec.capture_start_ep = 0;
      rec.total_base = now;
    }
    if (!rec.recording) {
      //console.log("EMN: audio skip "+at+" len "+audioBuffer.length+" net "+remaining);
      return;
    }
    rec.total = (rec.total | 0) + remaining;
    //if ((1000*rec.total/rec.sampleRate) > (now - rec.total_base + 1000)) {
    //  console.warn("EMN: audio skip "+at+" len "+audioBuffer.length+" net "+remaining+
    //               " "+(1000*rec.total/rec.sampleRate)+" > "+(now - rec.total_base));
    //}

    if (rec.numberOfAudioChannels == 1) {
      let cd = audioBuffer.getChannelData(0);
      while (remaining > 0) {
        if (!rec.lbuf) {
          rec.lbuf = new Float32Array(rec.bufferSize);
          rec.bat = 0;
        }
        let copy = rec.bufferSize - rec.bat;
        if (copy > remaining) { copy = remaining; }

        //console.log("at "+at+" rem "+remaining+" bat "+rec.bat+" copy "+copy);
        rec.lbuf.set(cd.slice(at,at+copy), rec.bat);
        rec.bat += copy;
        at += copy;
        remaining -= copy;
        if (rec.bat >= rec.bufferSize) {
          rec.ondataavailable(rec.sampleRate,
                              rec.numberOfAudioChannels,
                              rec.lbuf.buffer);
          delete rec.lbuf;
        }
      }
    } else {      
      let cd0 = audioBuffer.getChannelData(0);
      let cd1 = audioBuffer.getChannelData(1);
      while (remaining > 0) {
        if (!rec.lbuf) {
          rec.lbuf = new Float32Array(rec.bufferSize);
          rec.rbuf = new Float32Array(rec.bufferSize);
          rec.bat = 0;
        }
        let copy = rec.bufferSize - rec.bat;
        if (copy > remaining) { copy = remaining; }

        console.log("at "+at+" rem "+remaining+" bat "+rec.bat+" copy "+copy);
        rec.lbuf.set(cd0.slice(at,at+copy), rec.bat);
        rec.rbuf.set(cd1.slice(at,at+copy), rec.bat);
        rec.bat += copy;
        at += copy;
        remaining -= copy;
        if (rec.bat >= rec.bufferSize) {
          rec.ondataavailable(rec.sampleRate,
                              rec.numberOfAudioChannels,
                              rec.lbuf.buffer,
                              rec.rbuf.buffer);
          delete rec.lbuf;
          delete rec.rbuf;
        }
      }
    }
  }

  stop() {
    let rec = this;
    if (rec.outputNode) {
      rec.outputNode.disconnect();
      delete rec.outputNode;
    }
    if (rec.gainNode) {
      rec.gainNode.disconnect();
      delete rec.gainNode;
    }
    super.stop();
    if (rec.mr) {
      rec.mr.stop();
      delete rec.mr;
    }
  }
}

class AudioRecorderMR4 extends AudioRecorder {
  constructor(mediaStream, config) {
    super(config);
    let rec = this;
    rec.AudioContext = window.AudioContext || window.webkitAudioContext;
    rec.context = new rec.AudioContext();
    rec.bufferSize =
      (typeof config.bufferSize === 'undefined') ? 4096 : config.bufferSize;

    rec.outputNode = rec.context.createMediaStreamDestination();
    /* gainNode will be common sink for all input streams.
       Must occur before first addAudio(). */
    rec.gainNode = rec.context.createGain();
    rec.gainNode.connect(rec.outputNode);
    
    rec.mr = new MediaRecorder(rec.outputNode.stream,
                               {mimeType: "audio/mp4"
                               });
    rec.mr.ondataavailable = function(e) {
      if (!rec.mr) { return; }
      rec.onAudioDataAvailable(e);
    };
    rec.mr.onstop = function() {
      console.log("mr stop signaled");
      rec.stop();
    };
    /* Milliseconds per output slice */
    rec.mr.start(65);

    rec.addAudio(0,mediaStream);
    /* The output sampleRate of mediaRecorder appears to follow the
       audio context's sampleRate. It might be different than the
       stream's sampleRate. For example, Mac's streams are often 48K
       but their context (thus recorded PCM) are usually 44.1K */
    rec.sampleRate = rec.context.sampleRate;
    rec.audio_object_type = 2; // AAC LC
    rec.audio_frequency = 3; // 48000 Hz
    rec.audio_channel = 2; // 2 channels: front-left, front-right

    console.log(`audioRecMR4: Audio ch ${rec.numberOfAudioChannels} sr ${rec.sampleRate} sr ${rec.sampleRate} buf ${rec.bufferSize}`);
  }

  async onAudioDataAvailable(e) {
    let rec = this;
    let byteArray = new Uint8Array(await e.data.arrayBuffer()), box, desc;
    var sample_offsets;
    var aac_frame;
    var src_skip = rec.aac_chunk ? 1024 : 0;

    if (!byteArray.length && document.hidden) {
      rec.ondataavailable(rec.sampleRate,
                          rec.numberOfAudioChannels);
      return;
    }

    forEachMp4Box(byteArray, 0, byteArray.length, function(offset, length, t0, t1, t2, t3) {
      if (t0 == 109 && t1 == 111 && t2 == 111 && t3 == 118) { // moov
        box = findMp4Box(byteArray,offset,length, 116,114,97,107); // trak
        box = findMp4Box(byteArray,box.offset,box.length, 109,100,105,97); // mdia
        box = findMp4Box(byteArray,box.offset,box.length, 109,105,110,102); // minf
        box = findMp4Box(byteArray,box.offset,box.length, 115,116, 98, 108); // stbl
        box = findMp4Box(byteArray,box.offset,box.length, 115,116,115,100); // stsd
        box = findMp4Box(byteArray,box.offset+8,box.length-8, 109,112,52,97); // mp4a
        box = findMp4Box(byteArray,box.offset+28, box.length-28, 101,115,100,115); // esds
        desc = findMp4Descriptor(byteArray,box.offset+4,box.length-4,3); // es_descr
        if (desc.length >= 3) {
          var es_descr_flags = byteArray[desc.offset+2];
          desc.offset += 3;
          desc.length -= 3;
          if (es_descr_flags & 0x80) {
            desc.offset += 2;
            desc.length -= 2;
          }
          if (es_descr_flags & 0x40) {
            desc.offset += 1;
            desc.length -= 1;
          }
          if (es_descr_flags & 0x20) {
            desc.offset += 2;
            desc.length -= 2;
          }
          // decoder_config_descr
          desc = findMp4Descriptor(byteArray, desc.offset, desc.length, 4);
          // dec_specific_info
          desc = findMp4Descriptor(byteArray, desc.offset + 13, desc.length - 13, 5);
          if (desc.length >= 2) {
            // https://wiki.multimedia.cx/index.php/MPEG-4_Audio#Audio_Specific_Config
            rec.audio_object_type = (byteArray[desc.offset] >> 3);
            rec.audio_frequency = (((byteArray[desc.offset] & 0x7) << 1) +
                                   (byteArray[desc.offset+1] >> 7));
            rec.audio_channel = ((byteArray[desc.offset+1] >> 3) & 0xF);
          }
        }
        box = findMp4Box(byteArray,offset,length, 109,118,101,120); // mvex
        box = findMp4Box(byteArray,box.offset,box.length, 116,114,101,120); // trex
        if (box.length >= 24) {
          rec.default_sample_size = ((byteArray[box.offset+16]<<24) +
                                     (byteArray[box.offset+17]<<16) +
                                     (byteArray[box.offset+18]<<8) +
                                     byteArray[box.offset+19]);
        }
        // end: moov
      } else if (t0 == 109 && t1 == 111 && t2 == 111 && t3 == 102) { // moof
        var moof_start_offset = offset - 8;
        var frag_default_sample_size = rec.default_sample_size;
        var frag_data_offset = 0;
        var sample_offset = 0;
        sample_offsets = [];
        box = findMp4Box(byteArray,offset,length, 116,114,97,102); // traf
        forEachMp4Box(byteArray, box.offset, box.length, function(offset, length, t0, t1, t2, t3) {
          if (t0 == 116 && t1 == 102 && t2 == 104 && t3 == 100) { // tfhd
            if (length > 8) {
              // if present, update frag_default_sample_size and frag_data_offset
            }
          } else if (t0 == 116 && t1 == 114 && t2 == 117 && t3 == 110) { // trun
            if (length >= 8) {
              var flags = ((byteArray[offset+1]<<16) + (byteArray[offset+2]<<8) +
                           byteArray[offset+3]);
              var count = ((byteArray[offset+4]<<24) + (byteArray[offset+5]<<16) +
                           (byteArray[offset+6]<<8) + byteArray[offset+7]);
              length -= 8;
              offset += 8;
              if ((flags & 0x1) && length >= 4) { // data offset present
                sample_offset = (frag_data_offset + (byteArray[offset]<<24) +
                                 (byteArray[offset+1]<<16) + (byteArray[offset+2]<<8) +
                                 byteArray[offset+3]);
                length -= 4;
                offset += 4;
              }
              if ((flags & 0x4) && length >= 4) { // first sample flags present
                length -= 4;
                offset += 4;
              }
              var sample_size = frag_default_sample_size;
              for (var i = 0; i < count; i ++) {
                if ((flags & 0x100) && length >= 4) { // sample duration present
                  length -= 4;
                  offset += 4;
                }
                if ((flags & 0x200) && length >= 4) { // sample size present
                  sample_size = ((byteArray[offset]<<24) + (byteArray[offset+1]<<16) +
                                 (byteArray[offset+2]<<8) + byteArray[offset+3]);
                  length -= 4;
                  offset += 4;
                }
                if ((flags & 0x400) && length >= 4) { // sample flags present
                  length -= 4;
                  offset += 4;
                }
                if ((flags & 0x800) && length >= 4) { // sample composition time offsets present
                  length -= 4;
                  offset += 4;
                }
                sample_offsets.push([ moof_start_offset + sample_offset, sample_size ]);
                sample_offset += sample_size;
              }
            }
          } //end: trun
        }); //forEachMp4Box
        // end: moof
      } else if (t0 == 109 && t1 == 100 && t2 == 97 && t3 == 116) { // mdat
        sample_offsets && sample_offsets.forEach(function(sample) {
          if (sample[0] >= offset && sample[0] + sample[1] <= offset + length) {
            var frame_size = sample[1] + 7;
            var old_chunk = rec.aac_chunk;
            var old_length = old_chunk? old_chunk.length : 0;

            rec.aac_chunk = new Uint8Array(old_length + frame_size);
            old_length && rec.aac_chunk.set(old_chunk, 0);
            rec.aac_chunk.set(new Uint8Array(byteArray.buffer, sample[0], sample[1]),
                          old_length + 7);

            aac_frame = new Uint8Array(rec.aac_chunk.buffer, old_length, frame_size);
            aac_frame[0] = 0xFF;
            aac_frame[1] = 0xF1; // ADTS_VERSION_MPEG4, NO CRC
            aac_frame[2] = ((((rec.audio_object_type - 1) & 0x3) << 6) |
                            (rec.audio_frequency << 2) |
                            ((rec.audio_channel >> 2) & 0x1));
            aac_frame[3] = ((rec.audio_channel & 0x3) << 6) | ((frame_size >> 11) & 0x7);
            aac_frame[4] = ((frame_size >> 3) & 0xFF);
            aac_frame[5] = ((frame_size & 0x7) << 5) | 0x1F /* Buffer fullness */;
            aac_frame[6] = 0xFC; // Buffer fullness, 1 Block
          } else {
            console.warn("sample data out of mdat bound");
          }
        });
      } // end: mdat
    }); // forEachMp4Box

    if (aac_frame) {
      // NOTE: Safari doesn't support the promise/await syntax
      //       of decodeAudioData()
      rec.context.decodeAudioData(rec.aac_chunk.buffer, function(audioBuffer) {
        let cd0 = audioBuffer.getChannelData(0);
        let cd1 = audioBuffer.getChannelData(1);
        //console.log("Left "+cd0.length,"skip "+src_skip);
        if (!cd0.length) { return; }
        let at = src_skip;
        let remaining = cd0.length - at;
        while (remaining > 0) {
          if (!rec.lbuf) {
            rec.lbuf = new Float32Array(rec.bufferSize);
            rec.rbuf = new Float32Array(rec.bufferSize);
            rec.bat = 0;
          }
          let copy = rec.bufferSize - rec.bat;
          if (copy > remaining) { copy = remaining; }
          //if (rec.bat != 0 || copy != rec.bufferSize) {
          //  console.log("at "+at+" rem "+remaining+" bat "+rec.bat+" copy "+copy);
          //}
          rec.lbuf.set(cd0.slice(at,at+copy), rec.bat);
          rec.rbuf.set(cd1.slice(at,at+copy), rec.bat);
          rec.bat += copy;
          at += copy;
          remaining -= copy;
          if (rec.bat >= rec.bufferSize) {
            if (rec.numberOfAudioChannels == 1) {
              rec.ondataavailable(rec.sampleRate,
                                  rec.numberOfAudioChannels,
                                  rec.lbuf.buffer);
            } else {
              rec.ondataavailable(rec.sampleRate,
                                  rec.numberOfAudioChannels,
                                  rec.lbuf.buffer,
                                  rec.rbuf.buffer);
            }
            delete rec.lbuf;
            delete rec.rbuf;
          }
        } // remaining
      });
      rec.aac_chunk = aac_frame; // repeat last AAC frame
    }
  }

  stop() {
    let rec = this;
    if (rec.outputNode) {
      rec.outputNode.disconnect();
      delete rec.outputNode;
    }
    if (rec.gainNode) {
      rec.gainNode.disconnect();
      delete rec.gainNode;
    }
    super.stop();
    if (rec.mr) {
      rec.mr.stop();
      delete rec.mr;
    }
  }
}

class AudioRecorderWL extends AudioRecorder {
  constructor(mediaStream, config) {
    super(config);
    let rec = this;
    this.AudioContext = window.AudioContext || window.webkitAudioContext;
    this.context = new this.AudioContext(/*{sampleRate:44100}*/);
    this.bufferSize =
      (typeof config.bufferSize === 'undefined') ? 4096 : config.bufferSize;
    this.sampleRate = typeof config.sampleRate !== 'undefined' ? config.sampleRate : this.context.sampleRate || 44100;    

    rec.initial_stream = mediaStream;
    console.log(`audioRecWL: Audio ch ${this.numberOfAudioChannels} sr ${this.sampleRate} sr ${this.sampleRate} buf ${this.bufferSize}`);
  }

  async setup() {
    let rec = this;
    await rec.context.audioWorklet.addModule(process.env.BASE_URL +
                                             'legacy/js/audproc.js');

    rec.jsAudioNode = new AudioWorkletNode(rec.context, 'audcap');
    rec.jsAudioNode.port.onmessage = function(e) {
      if (rec.isPaused) {
        return;
      }
      if (!rec.isMediaStreamActive()) {
        console.log('audioRec: MediaStream has stopped.');
        rec.stop();
        return;
      }
      if (rec.capture_start_ep &&
          Date.now() >= rec.capture_start_ep) {
        console.log('audioRec: reached capture start_ep');
        rec.recording = true;
        rec.capture_start_ep = 0;
      }
      if (!rec.recording) {
        return;
      }

      if (e.data) {
        if (e.data.buffers) {
          if (rec.numberOfAudioChannels == 1) {
            rec.ondataavailable(rec.sampleRate,
                                rec.numberOfAudioChannels,
                                e.data.buffers[0]);
          } else if (rec.numberOfAudioChannels == 2) {
            rec.ondataavailable(rec.sampleRate,
                                rec.numberOfAudioChannels,
                                e.data.buffers[0],
                                e.data.buffers[1]);
          }
        }
      }
    }

    /* gainNode will be common sink for all input streams.
       Must occur before first addAudio() */
    rec.gainNode = rec.context.createGain();
    rec.gainNode.connect(rec.jsAudioNode);
    if (rec.context.createMediaStreamDestination) {
      rec.jsAudioNode.connect(rec.context.createMediaStreamDestination());
    } else {
      rec.jsAudioNode.connect(rec.context.destination);
    }
    
    rec.addAudio(0,rec.initial_stream);
    delete rec.initial_stream;
    rec.jsAudioNode.port.postMessage({'bufferSize':rec.bufferSize,
                                      'ch':rec.numberOfAudioChannels});
  }
  
  stop() {
    let rec = this;
    if (rec.jsAudioNode) {
      rec.jsAudioNode.port.postMessage({'stop':true});
      rec.jsAudioNode.disconnect();
      delete rec.jsAudioNode;
    }
    if (rec.gainNode) {
      rec.gainNode.disconnect();
      delete rec.gainNode;
    }
    super.stop();
  }
}

class AudioRecorderSP extends AudioRecorder {
  constructor(mediaStream, config) {
    super(config);
    let rec = this;
    this.Storage = {
      AudioContextConstructor: null,
      AudioContext: window.AudioContext || window.webkitAudioContext
    };    
    this.Storage.AudioContextConstructor = new this.Storage.AudioContext({});
    this.context = this.Storage.AudioContextConstructor;

    /* 0 lets device select */
    let legalBufferValues = [0, 256, 512, 1024, 2048, 4096, 8192, 16384];
    this.bufferSize =
      (typeof config.bufferSize === 'undefined') ? 4096 : config.bufferSize;
    if (legalBufferValues.indexOf(this.bufferSize) === -1) {
      throw('audioRec: legal values for buffer-size are '+
            JSON.stringify(legalBufferValues, null, '\t'));
    }

    if (this.context.createJavaScriptNode) {
      this.jsAudioNode = this.context.createJavaScriptNode(
        this.bufferSize, this.numberOfAudioChannels,
        this.numberOfAudioChannels);
    } else if (this.context.createScriptProcessor) {
      this.jsAudioNode = this.context.createScriptProcessor(
        this.bufferSize, this.numberOfAudioChannels,
        this.numberOfAudioChannels);
    } else {
      throw 'WebAudio API has no support on this browser.';
      }
    this.jsAudioNode.onaudioprocess = function(e) {
      rec.onAudioProcessDataAvailable(e);
    }

    /* gainNode will be common sink for all input streams.
       Must occur before first addAudio() */
    rec.gainNode = rec.context.createGain();
    rec.gainNode.connect(rec.jsAudioNode);
    if (rec.context.createMediaStreamDestination) {
      rec.jsAudioNode.connect(rec.context.createMediaStreamDestination());
    } else {
      rec.jsAudioNode.connect(rec.context.destination);
    }
    
    rec.addAudio(0, mediaStream);

    if (!this.bufferSize) {
      this.bufferSize = this.jsAudioNode.bufferSize;
    }
    
    this.sampleRate = typeof config.sampleRate !== 'undefined' ? config.sampleRate : this.context.sampleRate || 44100;
    if (this.sampleRate < 22050 || this.sampleRate > 96000) {
      throw('audioRec: sample-rate must be under range 22050 and 96000.');
    }
    console.log(`audioRecSP: Audio ch ${this.numberOfAudioChannels} sr ${this.sampleRate} sr ${this.sampleRate} buf ${this.bufferSize}`);
  }

  onAudioProcessDataAvailable(e) {
    let rec = this;
    if (rec.isPaused) {
      return;
    }
    if (!rec.isMediaStreamActive()) {
      console.log('audioRec: MediaStream has stopped.');
      rec.stop();
      return;
    }
    if (rec.capture_start_ep &&
        Date.now() >= rec.capture_start_ep) {
      console.log('audioRec: reached capture start_ep');
      rec.recording = true;
      rec.capture_start_ep = 0;
    }
    if (!rec.recording) {
      return;
    }

    let cd;
    let lbuf, rbuf;
    if (rec.numberOfAudioChannels == 1) {
      /* Some devices require the buffer to be copied */
      cd = e.inputBuffer.getChannelData(0);
      lbuf = cd.slice(0);
      rec.ondataavailable(rec.sampleRate,
                          rec.numberOfAudioChannels,
                          lbuf.buffer);
    } else if (rec.numberOfAudioChannels == 2) {
      cd = e.inputBuffer.getChannelData(0);
      lbuf = cd.slice(0);
      cd = e.inputBuffer.getChannelData(1);
      rbuf = cd.slice(0);
      rec.ondataavailable(rec.sampleRate,
                          rec.numberOfAudioChannels,
                          lbuf.buffer,
                          rbuf.buffer);
    }
  }

  stop() {
    let rec = this;
    if (rec.jsAudioNode) {
      rec.jsAudioNode.onaudioprocess = null;
      rec.jsAudioNode.disconnect();
      rec.jsAudioNode = null;
    }
    if (rec.gainNode) {
      rec.gainNode.disconnect();
      delete rec.gainNode;
    }
    super.stop();
  }
}

class VideoRecorder {
  constructor() {
    let rec = this;
    let body = document.getElementsByTagName("body")[0];

    rec.video_w = rec.raw_video_w = 0;
    rec.video_h = rec.raw_video_h = 0;
    rec.video = document.getElementById("__vrec_video");
    if (!rec.video) {
      rec.video = document.createElement("video");
      rec.video.muted = true;
      rec.video.autoPlay = true;
      //rec.video.controls = true;
      rec.video.setAttribute('playsinline', 'playsinline');
      rec.video.id = "__vrec_video";
      rec.video.style.display = "none";
      rec.video.style.width = "100%";
      rec.video.style.height = "100%";
      rec.video.addEventListener("loadedmetadata", (event) => {
        rec.videoDimensionSetup();
      });
      body.appendChild(rec.video);
    }

    rec.vcan = document.getElementById("_vrec_canvas");
    if (!rec.vcan) {
      rec.vcan = document.createElement("canvas");
      rec.vcan.id = "_vrec_canvas";
      //rec.vcan.style.display = "none";
      //rec.vcan.style.position = "fixed";
      //rec.vcan.style.bottom = "0";
      //rec.vcan.style.right = "0";
      rec.vcan.style["z-index"] = 1000;
      rec.vcan.style.width = "5px";
      rec.vcan.style.height = "5px";
      body.appendChild(rec.vcan);
    }
    rec.vctx = rec.vcan.getContext('2d', {/*alpha:false*/});

    rec.ptfrms = 0;
    rec.frms = 0;
    rec.fct = 2;
    rec.loopback_refresh = 30000;
    rec.special = {};
    rec.fmts = [];
    rec.seg_active = 1;
  }

  videoDimensionSetup() {
    let rec = this;
    console.log("videoDimensionSetup");
    if (!rec.video) { return; }
    if (!rec.video.videoWidth || !rec.video.videoHeight) { return; }
    if (rec.video.videoWidth == rec.raw_video_w &&
        rec.video.videoHeight == rec.raw_video_h &&
        window.orientation == rec.raw_orientation) { return; }

    let video_w = rec.video.videoWidth;
    let video_h = rec.video.videoHeight;
    rec.raw_video_w = video_w;
    rec.raw_video_h = video_h;
    rec.raw_orientation = window.orientation;

    if (rec.special.safari16_aspect_ratio_fix) {
      /* Erroneously comes up as 4:3 when actual 16:9 */
      if ((video_w / video_h) >= 1.3) {
        video_w = Math.trunc(1.778 * video_h);
        //rec.tmp.innerHTML = ("B3:"+video_w+"x"+video_h);
      }
    }

    if (rec.special.ios16_portrait_fix) {
      /* Portrait erroneously comes up as 16:9 instead of 9:16 */
      if (video_w > video_h && (""+window.orientation) == "0") {
        let tmp = video_w;
        video_w = video_h;
        video_h = tmp;
        //rec.tmp.innerHTML = ("B4:"+video_w+"x"+video_h);
      }
    }
    rec.vcan.width = video_w;
    rec.vcan.height = video_h;
    rec.video_w = video_w; 
    rec.video_h = video_h;
    if (rec.bg_loading) {
      /* This is simply a way to avoid a blank canvas while tensor etc.
       *   is loading and initializing. Changing vcan width/height clears
       *   the canvas so restore the placeholder here. */
      //rec.vctx.globalCompositeOperation = "copy";
      //rec.vctx.fillStyle = "rgba(180,180,180,1)";
      //rec.vctx.fillRect(0, 0, rec.vcan.width, rec.vcan.height);
    }
    if (vx && vx.debug) { console.log("update video wxh done",rec.video_w,rec.video_h); }
  }

  setStream(mediaStream, endcb) {
    let rec = this;
    if (!mediaStream) { return; }
    if (rec.vtrack) {
      rec.vtrack.stop();
      delete rec.vtrack;
    }
    rec.stream = mediaStream;
    rec.vtrack = mediaStream.getVideoTracks()[0];

    //rec.vtrack.onended = function(ev) {
    //  /* Unclear that it's worth handling this. It's primary useful
    //   *   for screen-share sources where "stop share" is clicked. However,
    //   *   we only handle camera sources here. It could apply if a 
    //   *   camera permission were retracted. The problem is that iOS
    //   *   in particular signals onend for old tracks during
    //   *   front/back camera switch and the timing of "old" track
    //   *   onend event is sometimes before setStream gets called. 
    //   *   If we do want to handle, a timeOut would be needed so that
    //   *   endcb is called only if no new stream is registered */
    //  if (ev.target.id == rec.vtrack.id) {
    //    /* Currently in-use track ended */
    //    if (vx && vx.debug) { console.log("Video track ended",ev); }
    //    endcb && endcb(ev);
    //    console.log("video track ended",ev.target.id);
    //  }
    //}
    rec.video.srcObject = mediaStream;
    rec.video.play();
    // Safari (only iOS Safari?): A new canvas stream is needed or else
    //   followed by a PRTC_replace otherwise the RTC stream will go dead
    //   when switching from front/back camera. Unclear why since there is
    //   no obvious coupling of the canvas to the actiale input media stream.
    //   However, vcanStream ends up active=false and its track ended.
    //   For all other devices, vcanStream can be created once and PRTC_replace
    //   is not required on mediaStream changes.
    // Leaving fps blank means send when updated
    rec.vcanStream = rec.vcan.captureStream();//(18);
  }

  capture(config) {
    let rec = this;

    if (config.loopback_refresh) {
      rec.loopback_refresh = config.loopback_refresh;
    }
    if (config.special) {
      rec.special = config.special;
      /* Mac Safari requires an attached/displayed canvas to work */
      if (rec.special.safari_visible_canvas) {
        rec.vcan.style.display = "block";
        if (vx && vx.debug) { console.warn("safari: visible canvas"); }
      }
    }
    if (config.fct) {
      //rec.frms_gop = 0;
      // 1 = no repeat; 2,3,etc. = repeat once,twice,etc. in encoder
      rec.fct = config.fct;
    }
    rec.ondataavailable = config.ondataavailable;

    rec.en_sm = false;
    rec.en_pt = false;
    if (rec.stream) {
      /* Can only send real video if there is a stream AND
         the requester wants real video sent */
      rec.en_sm = config.en_sm;
      rec.en_pt = config.en_pt;
    }

    if (config.fmts) {
      //console.log("videoRecorder: fmts "+JSON.stringify(config.fmts));
      rec.fmts = [];
      config.fmts && config.fmts.forEach(function(f,idx) {
        //console.log("fmt",f,idx);
        let fmt = {};
        fmt.fps = f.fps;
        fmt.fpg = f.fpg;
        fmt.width = f.w;
        fmt.height = f.h;
        
        if (!f.fpg) {
          throw "videoRecord: unexpected fpg "+f.fpg;
        }
        if (!f.fps || f.fps > 30) {
          throw "videoRecord: unexpected fps "+f.fps;
        }
        if (!f.w || f.w > 1920) {
          throw "videoRecord: unexpected width "+f.w;
        }
        if (!f.h || f.h > 1080) {
          throw "videoRecord: unexpected height "+f.h;
        }
        let elid = "__vrec_canvas"+idx;
        fmt.can = document.getElementById(elid);
        if (!fmt.can) {
          fmt.can = document.createElement("canvas");
          fmt.can.id = elid;
          fmt.can.style.display = "none";
          //body.appendChild(fmt.can);
        }
        fmt.ctx = fmt.can.getContext('2d', {alpha:false, willReadFrequently:true});
        rec.fmts.push(fmt);
      });
    }

    if (config.bg_ef) {
      let changed = false;
      if (config.bg_ef.isel) {
        changed = !rec.BG_enabled;
        rec.BG_enabled = true;
        rec.BG_img = new Image();
        rec.BG_img.src = config.bg_ef.img;
        rec.BG_img.crossOrigin = 'anonymous';
      } else {
        changed = !!rec.BG_enabled;
        rec.BG_enabled = false;
      }
      if (changed) {
        if (vx && vx.debug) { console.log("bg_ef CHANGED"); }
        rec.hideVideo();
        rec.showVideo(rec.el);
        if (rec.BG_enabled) {
          rec.setupBG();
        }
      }
    }

    if (rec.BG_enabled) {
      /* Mirroring occurs on bodypix input so clear vctx and
         small tile ctx transforms */
      rec.vctx.resetTransform();
      if (rec.fmts && rec.fmts[0]) {
        rec.fmts[0].ctx.resetTransform();
      }
    }
    /* config.mirror May be undefined if no real stream
       or if stream unchanged */
    if (config.mirror === true) {
      rec.video.style.transform = "scaleX(-1)";
      rec.mirror = true;
    } else if (config.mirror === false) {
      rec.video.style.transform = "";
      rec.vctx.resetTransform();
      if (rec.fmts && rec.fmts[0]) {
        rec.fmts[0].ctx.resetTransform();
      }
      rec.mirror = false;
    }
  }

  showVideo(el,style) {
    let rec = this;
    if (!el) { return; }
    rec.el = el;

    let pv = rec.BG_enabled ? rec.vcan : rec.video;
    pv.style.width = "100%";
    pv.style.height = "100%";
    pv.style["object-fit"] = "contain";
    pv.style["margin"] = "auto";
    pv.style.display = "block";
    if (style) {
      Object.keys(style).forEach(function(k) {
        pv.style[k] = style[k];
      });
    }

    /* Safari 16 and iOS16 loopback will sometimes not start
     *  unless srcObject is set AFTER the appendChild() */
    rec.el.appendChild(pv);
    rec.video.srcObject = rec.stream;

    //rec.video.pause();
    //if (rec.video.srcObject !== rec.stream) {
    //  rec.video.srcObject = rec.stream;
    //}
    //rec.stream.getTracks().forEach(function(t) {
    //  console.log(t);
    //});
    rec.video.play();
    //if (prom) {
    //  prom.then(function() {
    //    console.log("PLAY OK");
    //  }).catch(function(e) {
    //    console.warn("PLAY NOT OK",e);
    //    rec.stream.active = false;
    //  });
    //}

    rec.refreshcnt = rec.refreshcnt || 0;
    if (rec.loopback_refresh) {
      /* Mac Safari <= 15 seems to sporadically freeze loopback. Do NOT
       *  touch srcObject or it will flicker. */
      clearTimeout(rec.loop_tid);
      rec.loop_tid = setInterval(function() {
        //rec.tmp.innerHTML = ("R"+(rec.refreshcnt++)+
        //                     "p:"+rec.video.paused+" e:"+rec.video.ended);
        rec.el.appendChild(pv);
        rec.video.play();
      }, rec.loopback_refresh);
    }

    clearTimeout(rec.bg_tid);
    if (rec.BG_enabled && !rec.en_sm) {
      /* Background replacement is enabled but video isn't actually
         streaming. showVideo is for a preview. Use a timer to drive
         the frames for the preview. */
      rec.bg_tid = setInterval(function() {
        rec.outputBG(rec.video_w, rec.video_h);
        if (rec.vtrack) {
          rec.inputBG(rec.video_w, rec.video_h);
        }
      }, 100);
    }
  }

  hideVideo() {
    let rec = this;
    clearTimeout(rec.loop_tid);
    clearTimeout(rec.bg_tid);

    /* Always hide the base video */
    let body = document.getElementsByTagName("body")[0];
    //rec.video.style.display = "none";
    rec.video.style.width = "5px";
    rec.video.style.height = "5px";
    body.appendChild(rec.video);

    rec.vcan.style.width = "5px";
    rec.vcan.style.height = "5px";
    body.appendChild(rec.vcan);
  }

  frmSize() {
    return this.frm_size;
  }

  isStreamActive() {
    let rec = this;
    if ('active' in rec.stream) {
      if (!rec.stream.active) {
        return false;
      }
    } else if ('ended' in rec.stream) {
      if (rec.stream.ended) {
        return false;
      }
    }
    return true;
  }

  recordAt(start_ep) {
    let rec = this;
    if (!rec.capture_start_ep) {
      rec.capture_start_ep = start_ep;
    }
    rec.video.play();
  }

  stop() {
    let rec = this;
    delete rec.capture_start_ep;
    if (rec.video) {
      rec.video.remove();
      delete rec.video;
    }
    clearTimeout(rec.loop_tid);
    rec.fmts.forEach(function(f) {
      if (f.can) {
        f.can.remove();
        delete f.can;
      }
    });
    if (rec.vtrack) {
      rec.vtrack.stop();
      delete rec.vtrack;
    }
    if (rec.stream) {
      delete rec.stream;
      delete rec.vcanStream;
    }
  }

  setupTensor(cb) {
    let rec = this;
    if (!(rec.bg_tensor = document.getElementById("__tensor"))) {
      rec.bg_tensor = document.createElement('script');
      rec.bg_tensor.src = "https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@2.0.0/dist/tf.min.js";
      rec.bg_tensor.id = "__tensor";
      rec.bg_tensor._loading = true;
      rec.bg_tensor.onload = function() {
        if (vx && vx.debug) { console.warn("Tensor loaded"); }
        rec.bg_tensor._loading = false;
        cb && cb();
      };
      document.head.appendChild(rec.bg_tensor);
    } else {
      if (vx && vx.debug) { console.warn("Tensor exists"); }
      if (!rec.bg_tensor._loading) {
        cb && cb();
      }
    }
  }

  setupBodyPix(cb) {
    let rec = this;
    if (!(rec.bg_bodypix = document.getElementById("__bodypix"))) {
      rec.bg_bodypix = document.createElement('script');
      rec.bg_bodypix.src = "https://cdn.jsdelivr.net/npm/@tensorflow-models/body-pix@2.0";
      rec.bg_bodypix.id = "__bodypix";
      rec.bg_bodypix._loading = true;
      rec.bg_bodypix.onload = function() {
        if (vx && vx.debug) { console.warn("Body Pix Loaded"); }
        rec.bg_bodypix._loading = false;
        cb && cb();
      }
      document.head.appendChild(rec.bg_bodypix);
    } else {
      if (vx && vx.debug) { console.warn("Body Pix exists"); }
      if (!rec.bg_bodypix._loading) {
        cb && cb();
      }
    }
  }

  setupBG() {
    let rec = this;

    /* This is simply a way to avoid a blank canvas while tensor etc.
     *   is loading and initializing. */
    rec.bg_loading = true;
    //rec.vctx.globalCompositeOperation = "copy";
    //rec.vctx.fillStyle = "rgba(180,180,180,1)";
    //rec.vctx.fillRect(0, 0, rec.vcan.width, rec.vcan.height);

    rec.setupTensor(function() {
      rec.setupBodyPix(function() {
        if (rec.bodypix_model) {
          if (vx && vx.debug) { console.warn("Body Pix Model exists"); }
          rec.bg_loading = false;
          return;
        }

        let props = {
          architecture: 'MobileNetV1',
          // [better&slower]     8,16,32
          outputStride: 16,
          // [better&slower] 1.01, 1.0, 0.75, .50  [worse&faster]
          multiplier: 0.75,
          quantBytes: 4
        };

        rec.bodypix_model =
          bodyPix.load(props).then(function (loadedModel) {
            rec.bodypix_model = loadedModel;
            if (vx && vx.debug) { console.warn("Body Pix Model Loaded"); }

            if (!(rec.input_can = document.getElementById("__inputcan"))) {
              rec.input_can = document.createElement('canvas');
              rec.input_can.id = "__inputcan";
              if (vx && vx.debug) { console.warn("New input canvas"); }
            }
            rec.input_can.style.position = "fixed";
            rec.input_can.style.bottom = "0";
            rec.input_can.style.left = "0";
            //rec.input_can.style["z-index"] = 1000;
            //rec.input_can.style.width = "fit-content";//"5px";
            //rec.input_can.style.height = "fit-content";//"5px";
            rec.input_ctx = rec.input_can.getContext('2d');
            rec.seg_active = 0;
            rec.bg_loading = false;
            //let body = document.getElementsByTagName("body")[0];
            //body.appendChild(rec.input_can);
          }); // model
      }); //bodypix
    }); // tensor
  }

  outputBG(video_w, video_h) {
    let rec = this;
    if (rec.seg_active !== 2) { return; }
    //console.log("C",video_w,video_h);
    if (rec.output_img_mask) {
      rec.vctx.globalCompositeOperation = "copy";
      rec.vctx.putImageData(rec.output_img_mask, 0, 0);
      //delete rec.output_img_mask;
      rec.vctx.globalCompositeOperation = "source-in";
      //Safari gCO does not appear to work from video input
      //rec.vctx.drawImage(rec.video,0,0,video_w,video_h);
      rec.vctx.drawImage(rec.input_can,0,0,video_w,video_h);
      rec.vctx.globalCompositeOperation = "destination-over";
      if (rec.BG_img && rec.BG_img.complete && rec.BG_img.naturalWidth > 0 && rec.BG_img.naturalHeight > 0) {
        rec.vctx.drawImage(rec.BG_img, 0, 0, video_w, video_h);
      } else {
        rec.vctx.fillStyle = "rgba(38,67,115,1)";
        rec.vctx.fillRect(0, 0, video_w, video_h);
      }
    }
    rec.seg_active = 0;
  }

  inputBG(video_w, video_h) {
    let rec = this;
    if (rec.seg_active !== 0 || video_w < 16 || video_h < 16) { return; }
    let props = {
      flipHorizontal: false,
      internalResolution: 'high',
      segmentationThreshold: 0.7
    };
    rec.seg_active = 1;
    rec.input_can.width = video_w;
    rec.input_can.height = video_h;
    if (rec.mirror) {
      rec.input_ctx.setTransform(-1, 0, 0, 1, video_w, 0);
    }
    rec.input_ctx.drawImage(rec.video,0,0,video_w,video_h);
    //console.log("A",video_w,video_h,rec.video.videoWidth,rec.video.videoHeight);
    rec.bodypix_model.segmentPersonParts(rec.input_can, props).then(function(segs) {
      let img;
      if ((!(img = rec.output_img_mask)) ||
          img.width != rec.input_can.width ||
          img.height != rec.input_can.height) {
        rec.output_img_mask = img =
          new ImageData(rec.input_can.width,
                        rec.input_can.height);
      }
      let visible = false;
      //console.log("B",segs.data.byteLength,img.data.length);
      for (let i = 0, n = 0; i < img.data.length; i += 4, n++) {
        if (segs.data[n] !== -1) {
          //img.data[i+0] = 255;
          //img.data[i+1] = 0;
          //img.data[i+2] = 0;
          img.data[i+3] = 255;
          if (!visible) {
            for (let bb=-4; bb<5; bb++) {
              img.data[i+3-(4*bb)] = 256-(24*(5+bb));
            }
            i += 12;
            n += 3;
          }
          visible = true;
        } else {
          img.data[i+3] = 0;
          if (visible) {
            for (let bb=-4; bb<5; bb++) {
              img.data[i+3+(4*bb)] = 256-(24*(5+bb));
            }
            i += 12;
            n += 3;
          }
          visible = false;
        }
      } //for
      rec.seg_active = 2;
    });
  }
  
  tick() {
    let rec = this;
    let now = Date.now();
    let fi;
    let _y=[], _u=[], _v=[];

    if (!rec.ondataavailable ||
        !rec.capture_start_ep ||
        now < rec.capture_start_ep ||
        !rec.fmts || !rec.fmts[0]) {
      return;
    }

    let fmt = rec.fmts[0];
    let out_width = fmt.width;
    let out_height = fmt.height;
    let video_w = rec.video_w;//rec.video.videoWidth;
    let video_h = rec.video_h;//rec.video.videoHeight;
    let frms = fmt.fps * ((now - rec.capture_start_ep) / 1000);

    if (rec.BG_enabled) {
      rec.outputBG(video_w, video_h);
    }
    if (frms >= rec.ptfrms) {
      if (rec.en_pt && rec.BG_enabled) {
        rec.inputBG(video_w, video_h);
      } else if (rec.en_pt) {
        //rec.vcan.width = video_w;
        //rec.vcan.height = video_h;
        rec.vctx.globalCompositeOperation = "copy";
        if (rec.mirror) {
          rec.vctx.setTransform(-1, 0, 0, 1, video_w, 0);
        }
        rec.vctx.drawImage(rec.video,0,0,video_w,video_h);
      }
      /* There is no need for PT to try to catch up to meet
         the target framerate. */
      rec.ptfrms = Math.max(rec.ptfrms+1,frms);
    }

    //console.log("video frm "+frms.toFixed(2)+" "+rec.frms.toFixed(2));
    if (rec.frms && frms < rec.frms) {
      /* fps / fpg is expected to match across fmts */
      return;
    }

    let rgba;
    if (rec.en_sm) {
      /* Only drawImage/getImage if there is a non-zero sized video */
      let rw = video_w / out_width;
      let rh = video_h / out_height;
      let w_width, w_height, off_width, off_height;
      fmt.can.width = out_width;
      fmt.can.height = out_height;
      if (rw > rh) {
        w_width = out_width;
        w_height = video_h / rw;
        off_width = 0;
        off_height = out_height - w_height;
      } else {
        w_width = video_w / rh;
        w_height = out_height;
        off_width = out_width - w_width;
        off_height = 0;
      }
      if (rec.BG_enabled) {
        /* From video canvas */
        fmt.ctx.drawImage(rec.vcan,
                          off_width/2,
                          off_height/2,
                          w_width,
                          w_height);
      } else {
        if (rec.mirror) {
          fmt.ctx.setTransform(-1, 0, 0, 1, out_width, 0);
        }
        fmt.ctx.drawImage(rec.video,
                          off_width/2,
                          off_height/2,
                          w_width,
                          w_height);
      }
      rgba = fmt.ctx.getImageData(0,0,out_width,out_height).data;
    } else {
      /* Create an empty buffer to signal "nothing", aka black */
      rgba = new Uint8Array(0);
    }

    rec.ondataavailable(rec.fct,
                        rgba.buffer);
    rec.frms += rec.fct;
    return;
  }

};
  
